import { AnchorXDTO, AnchorYDTO } from '@/model';

export const justifyItemAnchorXMap = new Map([
  [AnchorXDTO.LEFT, 'flex-start'],
  [AnchorXDTO.CENTER, 'center'],
  [AnchorXDTO.RIGHT, 'flex-end'],
]);

export const alignItemAnchorYMap = new Map([
  [AnchorYDTO.TOP, 'flex-start'],
  [AnchorYDTO.MIDDLE, 'center'],
  [AnchorYDTO.BOTTOM, 'flex-end'],
]);
